const pad = (n) => String(n).padStart(2, '0');
export const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
const shift = (d, years, months) => {
  const day = d.getDate();
  const x = new Date(d.getFullYear() + years, d.getMonth() + months, 1);
  x.setDate(Math.min(day, new Date(x.getFullYear(), x.getMonth() + 1, 0).getDate()));
  return x;
};
const monthEnd = (d) => new Date(d.getFullYear(), d.getMonth() + 1, 0);

export const PRESETS = [
  { id: 'today', label: 'Today', range: (t) => [t, t] },
  { id: '7d', label: '7 days', range: (t) => [addDays(t, -6), t] },
  { id: '30d', label: '30 days', range: (t) => [addDays(t, -29), t] },
  { id: 'month', label: 'This month', range: (t) => [new Date(t.getFullYear(), t.getMonth(), 1), t], prev: ([s, e]) => [shift(s, 0, -1), shift(e, 0, -1)] },
  { id: 'lastmonth', label: 'Last month', range: (t) => [new Date(t.getFullYear(), t.getMonth() - 1, 1), new Date(t.getFullYear(), t.getMonth(), 0)], prev: ([s]) => [shift(s, 0, -1), monthEnd(shift(s, 0, -1))] },
  { id: 'year', label: 'This year', range: (t) => [new Date(t.getFullYear(), 0, 1), t], prev: ([s, e]) => [shift(s, -1, 0), shift(e, -1, 0)] },
  { id: 'lastyear', label: 'Last year', range: (t) => [new Date(t.getFullYear() - 1, 0, 1), new Date(t.getFullYear() - 1, 11, 31)], prev: ([s, e]) => [shift(s, -1, 0), shift(e, -1, 0)] },
];

// returns [start, end, prevStart?, prevEnd?] as YYYY-MM-DD
export const presetRange = (id) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const p = PRESETS.find((x) => x.id === id);
  const r = p.range(today);
  return [...r, ...(p.prev ? p.prev(r) : [])].map(iso);
};

export const pctChange = (cur, prev) => {
  if (!prev) return cur ? null : 0;
  return Math.round(((cur - prev) / prev) * 100);
};

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const bucketLabel = (b, unit) => {
  const [y, m, d] = b.split('-').map(Number);
  if (unit === 'month') return `${MONTHS[m - 1]} ${String(y).slice(2)}`;
  return `${MONTHS[m - 1]} ${d}`;
};

export const fmtDate = (s) => {
  const [y, m, d] = s.split('-').map(Number);
  return `${MONTHS[m - 1]} ${d}, ${y}`;
};
